module.exports = __webpack_public_path__ + "img/second-title-mobile.e2478046.png";